import { render, staticRenderFns } from "./CustomerSubscribtions.vue?vue&type=template&id=0675e3ce&"
import script from "./CustomerSubscribtions.vue?vue&type=script&lang=js&"
export * from "./CustomerSubscribtions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports